import { useSyncExternalStore } from "react";

const query = "(prefers-reduced-motion: no-preference)";
const subscribe = callback => {
  const media = window.matchMedia(query);
  media.addEventListener("change", callback);
  navigator.connection?.addEventListener?.("change", callback);
  return () => {
    media.removeEventListener("change", callback);
    navigator.connection?.removeEventListener?.("change", callback);
  };
};
const snapshot = () => window.matchMedia(query).matches && !navigator.connection?.saveData;

// Both server rendering and the initial hydration pass keep content static and visible.
export const useMotionEnabled = () => useSyncExternalStore(subscribe, snapshot, () => false);